// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609211734/js/" + chunkId + "." + {"44":"df8f26aa","225":"2a2fd68c","481":"a45e3a1d","486":"2aad0ae5","770":"13f72fe8"}[chunkId] + ".0.054886841398437025.chunk.js";
};